<template>
    <h1>Page not found</h1>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "NotFound",
});
</script>

<style scoped></style>
